'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNull2 = require('lodash/isNull');

var _isNull3 = _interopRequireDefault(_isNull2);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _sum2 = require('lodash/sum');

var _sum3 = _interopRequireDefault(_sum2);

var _round2 = require('lodash/round');

var _round3 = _interopRequireDefault(_round2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SERIALIZE_FIELDS, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24;

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _decimal = require('decimal.js');

var _decimal2 = _interopRequireDefault(_decimal);

var _constants = require('../constants');

var _util = require('../utils/util');

var _BaseModel2 = require('./BaseModel');

var _BaseModel3 = _interopRequireDefault(_BaseModel2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CENT = _constants.AppConstants.CENT,
    INTEREST_RATE_DECIMAL_PLACES = _constants.AppConstants.INTEREST_RATE_DECIMAL_PLACES,
    INTEREST_RATE_FRACTION_DECIMAL_PLACES = _constants.AppConstants.INTEREST_RATE_FRACTION_DECIMAL_PLACES,
    LIEN_MODELS = _constants.AppConstants.LIEN_MODELS;


var LEGAL_SERIALIZE_FIELDS = ['agreement_date', 'amount_owed_today', 'application', 'capital_fundings', 'case', 'contract_download_url', 'custom_field_data', 'fees', 'funding_amount', 'id', 'interest_start_date', 'invested_amount', 'is_confirmed', 'is_imported', 'is_open', 'link_application', 'minimum_duration', 'preset_contract_template', 'preset_contract_template_name', 'principal_amount', 'prior_funding', 'terms'];

var MEDICAL_SERIALIZE_FIELDS = ['billing_amount', 'codes', 'custom_field_data', 'id', 'is_open', 'label', 'medical_facility', 'medical_facility_contact', 'medical_provider', 'notes', 'purchase_amount', 'purchase_date', 'initial_service_date', 'end_service_date'];

var GENERIC_SERIALIZE_FIELDS = ['amount', 'custom_field_data', 'id', 'is_open', 'notes', 'acquisition_date'];

var SERIALIZE_FIELDS = (_SERIALIZE_FIELDS = {}, _defineProperty(_SERIALIZE_FIELDS, LIEN_MODELS.GENERIC.model, GENERIC_SERIALIZE_FIELDS), _defineProperty(_SERIALIZE_FIELDS, LIEN_MODELS.LEGAL_FUNDING.model, LEGAL_SERIALIZE_FIELDS), _defineProperty(_SERIALIZE_FIELDS, LIEN_MODELS.LEGACY.model, LEGAL_SERIALIZE_FIELDS), _defineProperty(_SERIALIZE_FIELDS, LIEN_MODELS.MEDICAL.model, MEDICAL_SERIALIZE_FIELDS), _SERIALIZE_FIELDS);

var LienModel = (0, _classAutobindDecorator2.default)(_class = (_class2 = function (_BaseModel) {
  _inherits(LienModel, _BaseModel);

  // istanbul ignore next
  function LienModel() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var flatStore = arguments[1];

    _classCallCheck(this, LienModel);

    var _this = _possibleConstructorReturn(this, (LienModel.__proto__ || Object.getPrototypeOf(LienModel)).call(this, flatStore));

    _initDefineProp(_this, 'agreement_date', _descriptor, _this);

    _initDefineProp(_this, 'amount_owed_today', _descriptor2, _this);

    _initDefineProp(_this, 'application', _descriptor3, _this);

    _initDefineProp(_this, 'capital_fundings', _descriptor4, _this);

    _initDefineProp(_this, 'case', _descriptor5, _this);

    _initDefineProp(_this, 'contract_download_url', _descriptor6, _this);

    _initDefineProp(_this, 'custom_field_data', _descriptor7, _this);

    _initDefineProp(_this, 'documents', _descriptor8, _this);

    _initDefineProp(_this, 'fees', _descriptor9, _this);

    _initDefineProp(_this, 'funded_date', _descriptor10, _this);

    _initDefineProp(_this, 'funding_amount', _descriptor11, _this);

    _initDefineProp(_this, 'id', _descriptor12, _this);

    _initDefineProp(_this, 'interest_start_date', _descriptor13, _this);

    _initDefineProp(_this, 'invested_amount', _descriptor14, _this);

    _initDefineProp(_this, 'is_confirmed', _descriptor15, _this);

    _initDefineProp(_this, 'is_open', _descriptor16, _this);

    _initDefineProp(_this, 'lien_returns', _descriptor17, _this);

    _initDefineProp(_this, 'link_application', _descriptor18, _this);

    _initDefineProp(_this, 'minimum_duration', _descriptor19, _this);

    _initDefineProp(_this, 'preset_contract_template', _descriptor20, _this);

    _initDefineProp(_this, 'prior_funding', _descriptor21, _this);

    _initDefineProp(_this, 'schedule_items', _descriptor22, _this);

    _initDefineProp(_this, 'terms', _descriptor23, _this);

    _initDefineProp(_this, 'type', _descriptor24, _this);

    _this.extend(data);
    return _this;
  }

  _createClass(LienModel, [{
    key: 'getTermsPercent',
    value: function getTermsPercent() {
      return (0, _mobx.toJS)(this.terms).map(function (term) {
        term.interest_rate = (0, _round3.default)(Number(term.interest_rate) * CENT, INTEREST_RATE_DECIMAL_PLACES);
        return term;
      });
    }
  }, {
    key: 'setTermPercent',
    value: function setTermPercent(idx, val) {
      // Rounding the fraction to the percentage's own precision would drop two of the decimal places
      // the user is allowed to type, turning 3.2567% into 3.26%.
      var interest_rate = (0, _round3.default)(Number(val) / CENT, INTEREST_RATE_FRACTION_DECIMAL_PLACES);
      this.terms[idx].interest_rate = interest_rate;
    }
  }, {
    key: 'calculatedPrincipal',
    value: function calculatedPrincipal(priorFunding) {
      var fees = (0, _sum3.default)((0, _mobx.toJS)(this.feesNonFlat()).map(function (i) {
        return Number(i.fee_amount || 0);
      })),
          funding = Number((0, _get3.default)(this, 'funding_amount', 0));

      // If we have a prior funding, use that for calculation
      if (priorFunding) {
        var buyout = Number((0, _get3.default)(priorFunding, 'buyout_amount', 0));
        return Number(fees + funding + buyout) || 0;
      }

      // If no prior funding exists, respect legacy value
      var buyoutLegacy = Number((0, _get3.default)(this, 'buyout', 0));
      return Number(fees + funding + buyoutLegacy) || 0;
    }
  }, {
    key: 'feesFlat',
    value: function feesFlat() {
      return (0, _get3.default)(this, 'fees', []).filter(function (i) {
        return !i.contributes_to_principal;
      });
    }
  }, {
    key: 'feesNonFlat',
    value: function feesNonFlat() {
      return (0, _get3.default)(this, 'fees', []).filter(function (i) {
        return i.contributes_to_principal;
      });
    }
  }, {
    key: 'addFee',
    value: function addFee(options) {
      var fee = Object.assign({ fee_amount: '', fee_type: '' }, options);
      this.fees.push(fee);
    }
  }, {
    key: 'addNonFlatFee',
    value: function addNonFlatFee() {
      this.addFee({ contributes_to_principal: true });
    }
  }, {
    key: 'addFlatFee',
    value: function addFlatFee() {
      this.addFee({ contributes_to_principal: false });
    }
  }, {
    key: 'addBuyout',
    value: function addBuyout() {
      var prior_funding = Object.assign({ buyout_amount: '', expiration_date: '', funder_name: '' });
      this.extend({ prior_funding: prior_funding });
    }
  }, {
    key: 'applyPreset',
    value: function applyPreset(preset) {
      var preset_terms = (0, _pick3.default)(preset, ['minimum_duration', 'terms']);
      preset_terms.preset_contract_template = preset.id;

      this.extend(preset_terms);
    }
  }, {
    key: 'getPreset',
    value: function getPreset(presets) {
      return (0, _find3.default)(presets, { id: this.preset_contract_template });
    }
  }, {
    key: 'serialize',
    value: function serialize() {
      var serializeFields = SERIALIZE_FIELDS[this.type || LIEN_MODELS.LEGAL_FUNDING.model],
          lien = (0, _pick3.default)(this, serializeFields);

      // Remove fees with no amount
      if (this.isPlaintiffFunding) {
        lien.fees = (0, _filter3.default)(lien.fees, function (fee) {
          return !(0, _isNull3.default)(fee.fee_amount);
        });
      }

      return lien;
    }
  }, {
    key: 'calculateBalance',
    value: function calculateBalance(amount_owed) {
      var reduction_percentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var excludeReturnAmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var returnAmountSum = this.returnAmountSum,
          reductionAmount = amount_owed * (reduction_percentage || 0),
          amountOwed = amount_owed - reductionAmount;


      if (!amountOwed || !returnAmountSum) {
        return amountOwed;
      }

      if (excludeReturnAmount) {
        return new _decimal2.default(amountOwed);
      }

      return new _decimal2.default(amountOwed).minus(new _decimal2.default(returnAmountSum));
    }
  }, {
    key: 'adjustedLienBalance',
    value: function adjustedLienBalance(amount_owed) {
      return this.calculateBalance(amount_owed);
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'returnLastRepaid',
    get: function get() {
      var stringMax = function stringMax(a, b) {
        return a > b ? a : b;
      };
      return this.lien_returns.map(function (lienReturn) {
        return lienReturn.matured_date;
      }).reduce(stringMax, '');
    }
  }, {
    key: 'returnAmountSum',
    get: function get() {
      return (0, _util.sumMoney)(this.lien_returns.map(function (lienReturn) {
        return lienReturn.actual_amount;
      }));
    }
  }, {
    key: 'returnExpectedSum',
    get: function get() {
      return (0, _util.sumMoney)(this.lien_returns.map(function (lienReturn) {
        return lienReturn.expected_amount;
      }));
    }
  }, {
    key: 'isPlaintiffFunding',
    get: function get() {
      return [LIEN_MODELS.LEGAL_FUNDING.model, LIEN_MODELS.LEGACY.model].includes(this.type);
    }
  }, {
    key: 'isMedicalFunding',
    get: function get() {
      return this.type === LIEN_MODELS.MEDICAL.model;
    }
  }, {
    key: 'isGenericLien',
    get: function get() {
      return this.type === LIEN_MODELS.GENERIC.model;
    }
  }, {
    key: 'current_lien_balance',
    get: function get() {
      return this.calculateBalance(this.amount_owed_today);
    }
  }, {
    key: 'experimental_lien_balance',
    get: function get() {
      return this.calculateBalance(this.amount_owed_today, 0, true);
    }
  }, {
    key: 'reduced_lien_balance',
    get: function get() {
      return this.calculateBalance(this.amount_owed_today, this.reduction_percentage);
    }
  }, {
    key: 'hasCoopInvestment',
    get: function get() {
      return this.amount_owed_to_coop !== null;
    }
  }]);

  return LienModel;
}(_BaseModel3.default), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'agreement_date', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'amount_owed_today', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'application', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'capital_fundings', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'case', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'contract_download_url', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'custom_field_data', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'documents', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'fees', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'funded_date', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'funding_amount', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'interest_start_date', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'invested_amount', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'is_confirmed', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'is_open', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'lien_returns', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'link_application', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, 'minimum_duration', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, 'preset_contract_template', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, 'prior_funding', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, 'schedule_items', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, 'terms', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class2)) || _class;

var _default = LienModel;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CENT, 'CENT', '/app/src/models/LienModel.js');
  reactHotLoader.register(INTEREST_RATE_DECIMAL_PLACES, 'INTEREST_RATE_DECIMAL_PLACES', '/app/src/models/LienModel.js');
  reactHotLoader.register(INTEREST_RATE_FRACTION_DECIMAL_PLACES, 'INTEREST_RATE_FRACTION_DECIMAL_PLACES', '/app/src/models/LienModel.js');
  reactHotLoader.register(LIEN_MODELS, 'LIEN_MODELS', '/app/src/models/LienModel.js');
  reactHotLoader.register(LEGAL_SERIALIZE_FIELDS, 'LEGAL_SERIALIZE_FIELDS', '/app/src/models/LienModel.js');
  reactHotLoader.register(MEDICAL_SERIALIZE_FIELDS, 'MEDICAL_SERIALIZE_FIELDS', '/app/src/models/LienModel.js');
  reactHotLoader.register(GENERIC_SERIALIZE_FIELDS, 'GENERIC_SERIALIZE_FIELDS', '/app/src/models/LienModel.js');
  reactHotLoader.register(SERIALIZE_FIELDS, 'SERIALIZE_FIELDS', '/app/src/models/LienModel.js');
  reactHotLoader.register(LienModel, 'LienModel', '/app/src/models/LienModel.js');
  reactHotLoader.register(_default, 'default', '/app/src/models/LienModel.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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